import {useCallback, useEffect, useState} from 'react'
import {useAppDispatch} from 'store'
import Search from "modules/Search";
import {useSelector} from "react-redux";
import debounce from 'lodash/debounce';
import {links} from "helper";
import combineLink from "helper/combineLink";
import navRoute from "helper/navRoute";
import { useRouter } from 'next/router'

const useDebounced = debounce((callback, args) => callback(args), 600);


const useSearch = () => {
    const search = useSelector((state) => state.search);
    const partner = useSelector((state) => state.partner);
    const [query, setQuery] = useState(search.query)
    const router = useRouter()
    const dispatch = useAppDispatch();
    const navigation = navRoute()

    const onSearch = useCallback((val) => {
        useDebounced(() => {
            dispatch(Search.store.search.actions.searchFetch(val))

            router.push({
                pathname: location.pathname,
                query: { ...router.query, query: val },
            })
        })
    }, [])

    const onClearSearchResult = useCallback((val) => {
        dispatch(Search.store.search.actions.searchClear())
    }, [])

    const handleSearch = (e) => {
        const val = e.target?.value || ''
        setQuery(val)
        onSearch(val)
    }

    const input = {
        value:query,
        onChange: handleSearch
    }


    const getResutlList = useCallback((val) => {
        const data = []

        search.data?.list?.forEach((item) => {
            data.push({
                is_partner: true,
                ...item.partner
            })

            if(item.products){
                item.products?.forEach((product) => {
                    data.push({
                        is_product: true,
                        ...product,
                        partner: item.partner
                    })
                })
            }
        })

        return data
    }, [search.data])

    const getMiniSiteResutlList = useCallback((val) => {
        const data = []

        search.data?.products?.forEach((item) => {
            data.push({
                is_product: true,
                partner: partner.data,
                ...item,
            })
        })

        console.log('data', data, partner.data)

        return data
    }, [search.data])

    const onClickProduct = useCallback((product) => {


         const isShop = product.partner.menuViewType === 1


        return () => {
            navigation.navigate(
                combineLink(
                    links.abs.partners,
                    product.partner.alias,
                    (isShop ? product.parentMenu : '')
                ), {item: product.id})
        };
    }, [])

    const onClickProductMiniSite = useCallback((product) => {


        const isShop = partner.data.menuViewType === 1


        return () => {
            navigation.navigate(
                combineLink(
                    links.abs.home,
                    product.alias,
                    (isShop ? product.parentMenu : '')
                ), {item: product.id})
        };
    }, [])

    useEffect(() => {
        console.log(router.query)

        if(router.query.query && !search.query){
            setQuery(router.query.query)
            onSearch(router.query.query)
        }
    }, [router.query.query])

    return {
        search,
        onSearch,
        onClearSearchResult,
        getResutlList,
        getMiniSiteResutlList,
        onClickProduct,
        onClickProductMiniSite,
        input
    }
}

export default useSearch
